import {useLocation, useParams} from "react-router-dom";
import {isPreLoginRole} from "~/helpers/roles";
import {consumerUrls} from "~/routes/consumerUrls";
import {useAuth} from "~/auth/useAuth";
import {useConsumerUser} from "~/contexts";

export const useAccountId = () => {
  const {userRole} = useAuth();
  const {preLoginContext} = useConsumerUser();
  const params = useParams<{accountId: string}>();
  const {pathname, state} = useLocation();

  if (isPreLoginRole(userRole)) {
    if (pathname === consumerUrls.accounts.url) return "";
    if (pathname === consumerUrls.login.url && state?.globalLogin) return "";
    return params.accountId || preLoginContext?.account_id || "";
  }
  return params.accountId || "";
};
